import { useGetOfferSubmissionsBySlugQuery } from 'common/slices/offerApi.slice';
import { useCallback, useMemo } from 'react';

export const useColumnRefetch = (
  offerSlug,
  searchTerm,
  isFavoriteParam,
  isCardCompact,
  questions,
  submissionsFilter,
) => {
  const queryArgs = useMemo(
    () => ({
      offerSlug,
      isFavorite: isFavoriteParam,
      search: searchTerm,
      withDetail: !isCardCompact,
      data: questions,
    }),
    [offerSlug, isFavoriteParam, searchTerm, isCardCompact, questions],
  );

  const { refetch: refetchAll } = useGetOfferSubmissionsBySlugQuery({
    ...queryArgs,
    phase: 'all',
    orderBy: submissionsFilter?.all,
  });

  const { refetch: refetchEvaluate } = useGetOfferSubmissionsBySlugQuery({
    ...queryArgs,
    phase: 'evaluate',
    orderBy: submissionsFilter?.evaluate,
  });

  const { refetch: refetchRank } = useGetOfferSubmissionsBySlugQuery({
    ...queryArgs,
    phase: 'rank',
    orderBy: submissionsFilter?.rank,
  });

  const { refetch: refetchInterview } = useGetOfferSubmissionsBySlugQuery({
    ...queryArgs,
    phase: 'interview',
    orderBy: submissionsFilter?.interview,
  });

  const refreshColumn = useCallback(
    (fromPhase, toPhase) => {
      const phaseToColumnIdMap = {
        all: 'candidates',
        evaluate: 'evaluation',
        rank: 'classification',
        interview: 'interview',
      };

      const ids = [fromPhase, toPhase].filter(Boolean);
      const uniqueColumnIds = Array.from(
        new Set(ids.map((p) => phaseToColumnIdMap[p] || p)),
      );

      uniqueColumnIds.forEach((columnId) => {
        if (columnId === 'candidates') refetchAll();
        else if (columnId === 'evaluation') refetchEvaluate();
        else if (columnId === 'classification') refetchRank();
        else if (columnId === 'interview') refetchInterview();
      });
    },
    [refetchAll, refetchEvaluate, refetchRank, refetchInterview],
  );

  return { refreshColumn };
};
